import { RootState } from '../store';

export const selectSocketStatus = (state: RootState) => state.socket.socketStatus;

export default {
  selectSocketStatus,
};
